import { ApiGetRequest } from './api-get-request';

export class PlayerTicketWinsRequest extends ApiGetRequest
{
    constructor(webapiBasepath: string)
    {
        super('playerticketwins', null, null, webapiBasepath);
    }
}
